import{createRippleEffect as e}from"../rippleCore.js";const n=new WeakMap;function t(t={}){return o=>{o&&(n.has(o)||function(t){t.addEventListener("pointerdown",(o=>{e(o,t,n.get(t))}))}(o),n.set(o,t))}}export{t as useRipple};
